import { connect } from 'react-redux';
import Carousel from './Carousel';

const mapStateToProps = ({ system: { isTouchDevice }}) => ({
  isTouchDevice
});

export default connect(mapStateToProps, null)(Carousel);
